







import Vue from 'vue'
import UiTag from '@/components/Ui/Tag/Tag.vue'
import Mailing from '@/models/mailing/mailing'
import {
  MAILING_STATUS_COMPLETED,
  MAILING_STATUS_DRAFT,
  MAILING_STATUS_PROGRESS,
  MAILING_STATUS_READY
} from '@/constants'

export default Vue.extend({
  props: {
    status: String,
    mailing: Object as () => Mailing
  },
  components: {
    UiTag
  },
  methods: {
    getTagTypeByStatus (status: string) {
      switch (status) {
        case MAILING_STATUS_DRAFT:
          return 'info'
          break;
        case MAILING_STATUS_READY:
          return 'success'
          break;
        case MAILING_STATUS_PROGRESS:
          return 'success'
          break;
        case MAILING_STATUS_COMPLETED:
          return 'success'
          break;
        default:
          return 'info'
          break;
      }
    }
  }
})
